import { render, staticRenderFns } from "./PaymentsFintoc.vue?vue&type=template&id=5af1ad3a&scoped=true&"
import script from "./PaymentsFintoc.vue?vue&type=script&lang=js&"
export * from "./PaymentsFintoc.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsFintoc.vue?vue&type=style&index=0&id=5af1ad3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af1ad3a",
  null
  
)

export default component.exports